import { Grid } from '@mui/material';

import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

import { translations } from 'locales/i18n';
import usePageHeading from 'utils/hooks/usePageHeading';

import { SettingsCard } from './components/SettingsCard';

export function AccessSettingsOverview() {
  const { t } = useTranslation();
  const location = useLocation();
  usePageHeading({
    heading: t(translations.pages.accessHandler.title()),
    headingProps: {
      back: location.state?.back ?? `/`
    }
  });

  return (
    <Grid container spacing={4} justifyContent="center">
      <Grid item xs={4}>
        <SettingsCard
          header="Entitlements"
          description="Sehe alle Entitlements und weitere Informationen"
          icon="fa-tag"
          to="/settings/access-handler/entitlements"
        />
      </Grid>
      <Grid item xs={4}>
        <SettingsCard
          header="Entitlement-Groups"
          description="Gruppiere Entitlements und verwalte ihre Beziehungen"
          icon="fa-layer-group"
          to="/settings/access-handler/entitlement-groups"
        />
      </Grid>
      <Grid item xs={4}>
        <SettingsCard
          header="Roles"
          description="Fasse Entitlement-Groups zu Rollen zusammen"
          icon="fa-users"
          to="/settings/access-handler/roles"
        />
      </Grid>
      <Grid item xs={4}>
        <SettingsCard
          header="Access-Permissions"
          description="Lege Zugriffsrechte für alle Rollen fest"
          icon="fa-key"
          to="/settings/access-handler/access-permissions"
        />
      </Grid>
      {/* <Grid item xs={4}>
          <SettingsCard
            header="Publication-Permissions"
            description="Verwalte Autoren- und Empfängerkreise für Beiträge"
            icon="fa-bullhorn"
            to="/settings/access-handler/publication-permissions"
          />
        </Grid> */}
    </Grid>
  );
}
